<template>
  <div>RWS</div>
</template>

<script setup lang="ts"></script>
